/**
 * Step 11: Estado Civil
 * Coleta informações sobre o estado civil do usuário
 */

import React, { useState } from 'react';
import { StepContainer, ChoiceButtons, StepNavigation } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

export const Step11_EstadoCivil: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState<Pick<FormData, 'maritalStatus'>>({ maritalStatus: data.maritalStatus || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const options = [
    { label: 'Solteiro(a)', value: 'single' },
    { label: 'Casado(a)', value: 'married' },
    { label: 'União Estável', value: 'stable-union' },
    { label: 'Divorciado(a)', value: 'divorced' },
    { label: 'Viúvo(a)', value: 'widowed' },
  ];

  const handleSelectOption = (value: string) => {
    setLocalData({ maritalStatus: value as 'single' | 'married' | 'stable-union' | 'divorced' | 'widowed' | '' });
    setErrors({});
  };

  const handleNext = () => {
    if (!localData.maritalStatus) {
      setErrors({ maritalStatus: 'Selecione seu estado civil' });
      return;
    }

    updateFields(localData);
    onNext({ maritalStatus: localData.maritalStatus as 'single' | 'married' | 'stable-union' | 'divorced' | 'widowed' });
  };

  return (
    <StepContainer
      title="Qual seu estado civil?"
      description="Precisamos saber seu estado civil"
    >
      <div>
        <ChoiceButtons
          options={options}
          selected={localData.maritalStatus}
          onSelect={handleSelectOption}
        />
        {errors.maritalStatus && (
          <p className="text-red-600 text-sm mt-2">{errors.maritalStatus}</p>
        )}
      </div>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step11_EstadoCivil;
